import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import './DateRangeSelector.css';
import { getFormattedDate, getMomentDate } from '../../../utils/momentUtils.js';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Amount } from 'ui';
import { BookerContext } from '../Booker.js';
import { cn, cnWithPrefix } from 'ui/lib/utils';
const CalendarIcon = ({ className }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    const customCn = useTailwindPrefix ? cnWithPrefix('tw-') : cn;
    return (_jsx("svg", Object.assign({ className: customCn({
            'h-[1em] overflow-visible box-content': !useTailwindPrefix,
            'tw-h-[1em] tw-overflow-visible tw-box-content': useTailwindPrefix,
        }, className), viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M10.6511 12C10.8455 12 11.0355 11.9414 11.1971 11.8315C11.3587 11.7216 11.4847 11.5654 11.5591 11.3827C11.6334 11.2 11.6529 10.9989 11.615 10.8049C11.5771 10.6109 11.4835 10.4327 11.346 10.2929C11.2086 10.153 11.0335 10.0578 10.8428 10.0192C10.6522 9.98063 10.4546 10.0004 10.275 10.0761C10.0954 10.1518 9.94194 10.28 9.83396 10.4444C9.72597 10.6089 9.66833 10.8022 9.66833 11C9.66833 11.2652 9.77187 11.5196 9.95618 11.7071C10.1405 11.8946 10.3905 12 10.6511 12ZM15.565 12C15.7593 12 15.9493 11.9414 16.111 11.8315C16.2726 11.7216 16.3985 11.5654 16.4729 11.3827C16.5473 11.2 16.5668 10.9989 16.5288 10.8049C16.4909 10.6109 16.3973 10.4327 16.2599 10.2929C16.1224 10.153 15.9473 10.0578 15.7567 10.0192C15.566 9.98063 15.3684 10.0004 15.1889 10.0761C15.0093 10.1518 14.8558 10.28 14.7478 10.4444C14.6398 10.6089 14.5822 10.8022 14.5822 11C14.5822 11.2652 14.6857 11.5196 14.87 11.7071C15.0543 11.8946 15.3043 12 15.565 12ZM10.6511 16C10.8455 16 11.0355 15.9414 11.1971 15.8315C11.3587 15.7216 11.4847 15.5654 11.5591 15.3827C11.6334 15.2 11.6529 14.9989 11.615 14.8049C11.5771 14.6109 11.4835 14.4327 11.346 14.2929C11.2086 14.153 11.0335 14.0578 10.8428 14.0192C10.6522 13.9806 10.4546 14.0004 10.275 14.0761C10.0954 14.1518 9.94194 14.28 9.83396 14.4444C9.72597 14.6089 9.66833 14.8022 9.66833 15C9.66833 15.2652 9.77187 15.5196 9.95618 15.7071C10.1405 15.8946 10.3905 16 10.6511 16ZM15.565 16C15.7593 16 15.9493 15.9414 16.111 15.8315C16.2726 15.7216 16.3985 15.5654 16.4729 15.3827C16.5473 15.2 16.5668 14.9989 16.5288 14.8049C16.4909 14.6109 16.3973 14.4327 16.2599 14.2929C16.1224 14.153 15.9473 14.0578 15.7567 14.0192C15.566 13.9806 15.3684 14.0004 15.1889 14.0761C15.0093 14.1518 14.8558 14.28 14.7478 14.4444C14.6398 14.6089 14.5822 14.8022 14.5822 15C14.5822 15.2652 14.6857 15.5196 14.87 15.7071C15.0543 15.8946 15.3043 16 15.565 16ZM5.73725 12C5.93162 12 6.12163 11.9414 6.28325 11.8315C6.44486 11.7216 6.57083 11.5654 6.64521 11.3827C6.71959 11.2 6.73906 10.9989 6.70113 10.8049C6.66321 10.6109 6.56961 10.4327 6.43217 10.2929C6.29473 10.153 6.11962 10.0578 5.92898 10.0192C5.73834 9.98063 5.54074 10.0004 5.36116 10.0761C5.18158 10.1518 5.02809 10.28 4.9201 10.4444C4.81212 10.6089 4.75448 10.8022 4.75448 11C4.75448 11.2652 4.85802 11.5196 5.04232 11.7071C5.22663 11.8946 5.4766 12 5.73725 12ZM17.5305 2H16.5477V1C16.5477 0.734784 16.4442 0.48043 16.2599 0.292893C16.0756 0.105357 15.8256 0 15.565 0C15.3043 0 15.0543 0.105357 14.87 0.292893C14.6857 0.48043 14.5822 0.734784 14.5822 1V2H6.72002V1C6.72002 0.734784 6.61648 0.48043 6.43217 0.292893C6.24787 0.105357 5.99789 0 5.73725 0C5.4766 0 5.22663 0.105357 5.04232 0.292893C4.85802 0.48043 4.75448 0.734784 4.75448 1V2H3.77171C2.98977 2 2.23985 2.31607 1.68694 2.87868C1.13402 3.44129 0.823395 4.20435 0.823395 5V17C0.823395 17.7956 1.13402 18.5587 1.68694 19.1213C2.23985 19.6839 2.98977 20 3.77171 20H17.5305C18.3124 20 19.0624 19.6839 19.6153 19.1213C20.1682 18.5587 20.4788 17.7956 20.4788 17V5C20.4788 4.20435 20.1682 3.44129 19.6153 2.87868C19.0624 2.31607 18.3124 2 17.5305 2ZM18.5133 17C18.5133 17.2652 18.4097 17.5196 18.2254 17.7071C18.0411 17.8946 17.7911 18 17.5305 18H3.77171C3.51106 18 3.26109 17.8946 3.07678 17.7071C2.89248 17.5196 2.78894 17.2652 2.78894 17V8H18.5133V17ZM18.5133 6H2.78894V5C2.78894 4.73478 2.89248 4.48043 3.07678 4.29289C3.26109 4.10536 3.51106 4 3.77171 4H17.5305C17.7911 4 18.0411 4.10536 18.2254 4.29289C18.4097 4.48043 18.5133 4.73478 18.5133 5V6ZM5.73725 16C5.93162 16 6.12163 15.9414 6.28325 15.8315C6.44486 15.7216 6.57083 15.5654 6.64521 15.3827C6.71959 15.2 6.73906 14.9989 6.70113 14.8049C6.66321 14.6109 6.56961 14.4327 6.43217 14.2929C6.29473 14.153 6.11962 14.0578 5.92898 14.0192C5.73834 13.9806 5.54074 14.0004 5.36116 14.0761C5.18158 14.1518 5.02809 14.28 4.9201 14.4444C4.81212 14.6089 4.75448 14.8022 4.75448 15C4.75448 15.2652 4.85802 15.5196 5.04232 15.7071C5.22663 15.8946 5.4766 16 5.73725 16Z", fill: "currentColor" }) })));
};
export const DateRangeSelector = ({ id, rates, value, onChange, locale, dateRangePickerProps, myErrors, isMobile, numberOfMonths, vertical: propsVertical, }) => {
    const { vertical: contextVertical, useTailwindPrefix, version, showLabels } = useContext(BookerContext);
    const [focusedInput, setFocusedInput] = useState(null);
    const [startDate, setStartDate] = useState(getMomentDate(value === null || value === void 0 ? void 0 : value.startDate, locale));
    const [endDate, setEndDate] = useState(getMomentDate(value === null || value === void 0 ? void 0 : value.endDate, locale));
    const [direction, setDirection] = useState(null);
    const intl = useIntl();
    const vertical = propsVertical !== undefined ? propsVertical : contextVertical;
    useEffect(() => {
        setStartDate(getMomentDate(value === null || value === void 0 ? void 0 : value.startDate, locale));
        setEndDate(getMomentDate(value === null || value === void 0 ? void 0 : value.endDate, locale));
    }, [value, locale, rates]);
    useEffect(() => {
        const onScrollEvent = () => {
            calculateDirection();
        };
        window && window.addEventListener('scrollend', onScrollEvent);
        return () => {
            window && window.removeEventListener('scrollend', onScrollEvent);
        };
    }, []);
    const onFocusChange = (arg) => {
        setFocusedInput(arg);
        calculateDirection();
        if (document && document.body) {
            if (arg === null) {
                if (!useTailwindPrefix) {
                    document.body.className = document.body.className.replace(/ ?fixed md:relative/, '');
                }
                else {
                    document.body.className = document.body.className.replace(/ ?tw-fixed md:tw-relative/, '');
                }
            }
            else {
                let orig = document.body.className;
                if (!useTailwindPrefix) {
                    if (orig.indexOf('fixed md:relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'fixed md:relative';
                    }
                }
                else {
                    if (orig.indexOf('tw-fixed md:tw-relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'tw-fixed md:tw-relative';
                    }
                }
            }
        }
    };
    const onDatesChange = (arg) => {
        setStartDate(arg.startDate);
        setEndDate(arg.endDate);
        onChange({
            startDate: getFormattedDate(arg.startDate, locale, 'YYYY-MM-DD'),
            endDate: getFormattedDate(arg.endDate, locale, 'YYYY-MM-DD'),
        });
    };
    moment.locale(locale);
    const renderPrice = (day) => {
        const days = rates === null || rates === void 0 ? void 0 : rates.days;
        const months = (rates === null || rates === void 0 ? void 0 : rates.months) || [];
        if (day < moment().startOf('day')) {
            return null;
        }
        const month = day.format('YYYY-MM');
        const dayQuote = days ? days[day.format('YYYY-MM-DD')] : null;
        const lastDay = (rates === null || rates === void 0 ? void 0 : rates.lastProcessedDate) || moment().add(6, 'months');
        if (months.indexOf(month) > -1 && !dayQuote && (day.isBefore(lastDay) || day.isSame(lastDay))) {
            return _jsx("small", { className: "itm-drs-fetching" });
        }
        return dayQuote ? renderRate(dayQuote) : null;
    };
    const renderRate = (dayQuote) => {
        return dayQuote.isAvailable ? renderValidAmount(dayQuote) : renderInvalidAmount();
    };
    const renderValidAmount = (dayQuote) => {
        if (dayQuote.amount < 1) {
            return null;
        }
        return (_jsx("small", Object.assign({ className: classNames({
                block: !useTailwindPrefix,
                'itm-drs-lowestRate': dayQuote.isLowestRate,
            }) }, { children: _jsx(Amount, { amount: dayQuote.amount, currency: "", showCurrency: false }) })));
    };
    const renderInvalidAmount = () => {
        return (_jsx("div", { children: _jsx("span", Object.assign({ className: classNames('itm-drs-withoutRate') }, { children: "--" })) }));
    };
    const calculateDirection = () => {
        if (typeof window !== 'undefined') {
            const input = document.getElementById(`${id}.startDateId`);
            if (input) {
                const rect = input.getBoundingClientRect();
                const spaceBelow = window.innerHeight - rect.bottom;
                const height = rates ? 420 : 375;
                if (spaceBelow < height && rect.top > height) {
                    setDirection('up');
                    return;
                }
            }
        }
        setDirection('down');
    };
    const renderDayContentsCustom = (day) => {
        return (_jsxs("span", Object.assign({ className: "itm-drs-bookerDay" }, { children: [day.format('D'), rates && rates.days && rates.months && renderPrice(day)] })));
    };
    return (_jsxs("div", Object.assign({ className: classNames({
            'mb-5': myErrors && !useTailwindPrefix,
            'tw-mb-5': myErrors && useTailwindPrefix,
            'md:mb-0': myErrors && !vertical && !useTailwindPrefix,
            'md:tw-mb-0': myErrors && !vertical && useTailwindPrefix,
        }) }, { children: [_jsxs("div", Object.assign({ className: classNames('itm-drs', {
                    'itm-drs-h': !vertical,
                    'itm-drs--error': myErrors,
                    relative: version === 'padded' && !isMobile && !vertical && !useTailwindPrefix,
                    'tw-relative': version === 'padded' && !isMobile && !vertical && useTailwindPrefix,
                }) }, { children: [(startDate || endDate) && version === 'padded' && !isMobile && !vertical && showLabels && (_jsx("div", Object.assign({ className: classNames({
                            'absolute flex inset-0 text-widget-pill-a11y/75': !useTailwindPrefix,
                            'tw-absolute tw-flex tw-inset-0 tw-text-widget-pill-a11y/75': useTailwindPrefix,
                        }) }, { children: [
                            intl.formatMessage({ id: 'booker.checkIn' }),
                            ...(endDate ? [intl.formatMessage({ id: 'booker.checkOut' })] : []),
                        ].map((name) => (_jsxs("div", Object.assign({ className: classNames({
                                'w-1/2 flex': !useTailwindPrefix,
                                'tw-w-1/2 tw-flex': useTailwindPrefix,
                            }) }, { children: [_jsx("div", { className: classNames({
                                        'ml-[10px] w-4': !useTailwindPrefix,
                                        'tw-ml-[10px] tw-w-4': useTailwindPrefix,
                                    }) }), _jsx("div", Object.assign({ className: classNames({
                                        'px-[9px] text-xs': !useTailwindPrefix,
                                        'tw-px-[9px] tw-text-xs': useTailwindPrefix,
                                    }) }, { children: name }))] })))) }))), locale && (_jsx(DateRangePicker, Object.assign({}, (direction && {
                        openDirection: direction,
                    }), { noBorder: version === 'padded' && !isMobile && !vertical, firstDayOfWeek: 1, daySize: 50, transitionDuration: 0, startDate: startDate, startDateId: `${id}.startDateId`, endDate: endDate, endDateId: `${id}.endDateId`, onDatesChange: onDatesChange, focusedInput: focusedInput, onFocusChange: onFocusChange, readOnly: true, hideKeyboardShortcutsPanel: true, numberOfMonths: numberOfMonths }, (isMobile && {
                        orientation: 'vertical',
                        withFullScreenPortal: true,
                    }), (rates && {
                        renderDayContents: renderDayContentsCustom,
                    }), { horizontalMargin: 30, verticalSpacing: 25 }, (dateRangePickerProps
                        ? dateRangePickerProps
                        : {
                            minimumNights: 1,
                            showClearDates: true,
                            showDefaultInputIcon: true,
                        }), (version === 'padded' &&
                        !isMobile &&
                        !vertical &&
                        showLabels && {
                        customInputIcon: (_jsx(CalendarIcon, { className: classNames({ 'text-sm': !useTailwindPrefix, 'tw-text-sm': useTailwindPrefix }) })),
                        customArrowIcon: (_jsx("div", Object.assign({ className: classNames({
                                'h-[45px] border-l flex items-center -ml-2': !useTailwindPrefix,
                                'tw-h-[45px] tw-border-l tw-flex tw-items-center -tw-ml-2': useTailwindPrefix,
                            }) }, { children: _jsx(CalendarIcon, { className: classNames({
                                    'text-sm ml-3': !useTailwindPrefix,
                                    'tw-text-sm tw-ml-3': useTailwindPrefix,
                                }) }) }))),
                        showClearDates: false,
                    }))))] })), myErrors && (_jsx("div", Object.assign({ className: classNames(Object.assign({}, (!useTailwindPrefix
                    ? {
                        'absolute mt-1 text-sm': true,
                        'bg-transparent text-red-400 w-auto md:left-0': vertical,
                        'itm-error-bubble text-red-400 w-full max-w-[90%] md:mt-widget-pill-padding-y': !vertical,
                        'md:top-[90%]': !vertical && !showLabels,
                        'md:top-[75%]': !vertical && showLabels && version === 'padded',
                    }
                    : {
                        'tw-absolute md:tw-mt-1 tw-text-sm': true,
                        'tw-bg-transparent tw-text-red-400 tw-w-auto md:tw-left-0': vertical,
                        'itm-error-bubble tw-text-red-400 tw-w-full tw-max-w-[90%] md:tw-mt-widget-pill-padding-y': !vertical,
                        'md:tw-top-[90%]': !vertical && !showLabels,
                        'md:tw-top-[75%]': !vertical && showLabels && version === 'padded',
                    }))) }, { children: _jsx("div", Object.assign({ className: classNames({
                        'truncate w-full': !useTailwindPrefix,
                        'tw-truncate tw-w-full': useTailwindPrefix,
                    }) }, { children: myErrors.message || intl.formatMessage({ id: 'booker.errors.correctFields' }) })) })))] })));
};
